export const GOOGLE_MAPS_API_KEY = 'AIzaSyDWHjDz4sMI4vJjhxpieRlIwGp2xz8zXN0'
